// src/components/ChallengesPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuLayout from "./MenuLayout";
import "../styles/ChallengesPage.css";
import { getAccountChallenges, getBrokers, updateChallengeBroker } from "../api/challenge";

const ChallengeBlock = ({ challenge, disableBroker, onOpenModal, onAnalyze }) => {
  const items = [
    { id: 1, label: "شماره حساب", value: challenge.account_number || "—", icon: "/images/icons/account-number.svg" },
    { id: 2, label: "پلن", value: challenge.plan_name || "—", icon: "/images/icons/account-type.svg" },
    { id: 3, label: "بالانس", value: challenge.balance ?? "—", icon: "/images/icons/account-equity.svg" },
    { id: 4, label: "اکوئیتی", value: challenge.equti ?? "—", icon: "/images/icons/account-equity.svg" },
    { id: 5, label: "سود", value: challenge.profit ?? "—", icon: "/images/icons/account-status.svg" },
    { id: 6, label: "وضعیت", value: challenge.challenge_status || "—", icon: "/images/icons/account-status.svg" },
  ];

  return (
    <div className="ch-block">
      <div className="ch-cards-row">
        {items.map((acc) => (
          <div className="ch-card" key={acc.id}>
            <div className="ch-card-icon">
              <img src={acc.icon} alt={acc.label} />
            </div>
            <div className="ch-card-label">{acc.label}</div>
            <div className="ch-card-value">{acc.value}</div>
          </div>
        ))}
      </div>
      <div className="ch-actions">
        <button className="ch-btn ch-btn-analyze" onClick={onAnalyze} disabled={!challenge.account_number}>تحلیل حساب!</button>
        <button className="ch-btn ch-btn-broker" disabled={disableBroker} onClick={onOpenModal}>
          تغییر بروکر
        </button>
      </div>
    </div>
  );
};

const ChallengesPage = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [challenges, setChallenges] = useState([]);
  const [error, setError] = useState("");
  const [brokers, setBrokers] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountPassword, setAccountPassword] = useState("");
  const [modalError, setModalError] = useState("");
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
    const fetchChallenges = async () => {
      try {
        const data = await getAccountChallenges();
        const allLists = Object.values(data || {}).filter(Boolean).flat();
        setChallenges(allLists);
      } catch (err) {
        console.error("challenges fetch error", err);
        setError("خطا در دریافت چالش‌ها");
      }
    };
    const fetchBrokers = async () => {
      try {
        const data = await getBrokers();
        setBrokers(data || []);
      } catch (err) {
        console.error("brokers fetch error", err);
      }
    };
    fetchChallenges();
    fetchBrokers();
  }, []);

  const openModalFor = (challenge) => {
    setSelectedChallenge(challenge);
    setSelectedBroker(challenge?.broker_name || "");
    setAccountNumber(challenge?.account_number || "");
    setAccountPassword("");
    setModalError("");
    setShowModal(true);
  };

  const closeModal = () => {
    if (modalLoading) return;
    setShowModal(false);
    setModalError("");
  };

  const handleBrokerUpdate = async () => {
    if (!selectedChallenge) {
      setModalError("چالشی انتخاب نشده است.");
      return;
    }
    if (!selectedBroker) {
      setModalError("لطفاً بروکر را انتخاب کنید.");
      return;
    }
    if (!accountNumber) {
      setModalError("لطفاً شماره حساب را وارد کنید.");
      return;
    }
    if (!accountPassword) {
      setModalError("لطفاً رمز حساب را وارد کنید.");
      return;
    }
    setModalLoading(true);
    setModalError("");
    try {
      await updateChallengeBroker(selectedChallenge.id, {
        broker_name: selectedBroker,
        account_number: accountNumber,
        account_paswoord: accountPassword,
      });
      setChallenges((prev) =>
        prev.map((ch) =>
          ch.id === selectedChallenge.id
            ? { ...ch, broker_name: selectedBroker, account_number: accountNumber }
            : ch
        )
      );
      setShowModal(false);
      setAccountPassword("");
    } catch (err) {
      setModalError(err?.message || "خطا در ثبت تغییر بروکر");
    } finally {
      setModalLoading(false);
    }
  };

  return (
    <MenuLayout>
      <div className="ch-page">
        <header className="ch-header">
          <h1 className="ch-title">چالش‌های من</h1>
          <p className="ch-subtitle">
            ورود کن؛ هر چالشی یک قدم تو رو به تریدر قوی‌تر تبدیل می‌کنه
          </p>
        </header>

        {error && <div className="ch-empty">{error}</div>}
        {!error && challenges.length === 0 && <div className="ch-empty">چالشی برای شما ثبت نشده است</div>}

        {!error &&
          challenges.map((ch) => (
            <ChallengeBlock
              key={ch.id || ch.account_number}
              challenge={ch}
              onOpenModal={() => openModalFor(ch)}
              onAnalyze={() => (ch.account_number ? navigate(`/analysis/${ch.account_number}`) : null)}
              disableBroker={Number(ch.account_type ?? ch.broker_Type ?? ch.broker_type) === 1}
            />
          ))}

        {showModal && (
          <div className="ch-modal-backdrop" onClick={closeModal}>
            <div className="ch-modal" onClick={(e) => e.stopPropagation()}>
              <h3 className="ch-modal-title">تغییر بروکر</h3>
              <div className="ch-modal-form">
                {modalError && <div className="ch-modal-error">{modalError}</div>}
                <label className="ch-modal-field">
                  <span>نام بروکر:</span>
                  <select
                    value={selectedBroker}
                    onChange={(e) => setSelectedBroker(e.target.value)}
                    className="ch-select"
                  >
                    <option value="">انتخاب بروکر</option>
                    {brokers.map((b) => (
                      <option key={b.id || b.name} value={b.name}>
                        {b.name}
                      </option>
                    ))}
                  </select>
                </label>
                <label className="ch-modal-field">
                  <span>شماره حساب:</span>
                  <input type="text" placeholder="123456789" value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} />
                </label>
                <label className="ch-modal-field">
                  <span>رمز عبور:</span>
                  <input type="password" placeholder="********" value={accountPassword} onChange={(e) => setAccountPassword(e.target.value)} />
                </label>
                <button className="ch-btn ch-btn-analyze ch-modal-submit" onClick={handleBrokerUpdate} disabled={modalLoading}>{modalLoading ? "در حال ثبت..." : "ثبت"}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </MenuLayout>
  );
};

export default ChallengesPage;
